module.exports = __webpack_public_path__ + "img/gold.e754eb54.svg";